export default "__VITE_ASSET__zL2aYhUb__"